<template>
  <Card :showBtn="false" :btnMsg="$t('thanks.btn_text')">
    <div class="card-thanks">
      <div class="bg"></div>
      <div class="card-content">
        <div class="done-step-dots" aria-hidden="true"><i>✓</i><b></b><i>✓</i><b></b><i>3</i></div>
        <div class="done-ring" aria-hidden="true"><svg class="done-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12 L10 18 L20 6" /></svg></div>
        <div class="card-title" v-html="$t('thanks.title')"></div>
        <div>
          <div class="card-title-desc" v-html="title_desc"></div>
          <!-- <div class="card-title-desc" v-html="$t('thanks.title_desc2')"></div> -->
        </div>
      </div>
      <van-icon name="cross" @click="cancel" />
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed:{
    title_desc(){
        let default_paypal = this.form.default_paypal
        console.log(default_paypal,'default_paypal')
        if (default_paypal) {
          return this.$t('thanks.title_default_paypal_desc1')
        }else{
          return this.$t('thanks.title_default_paypal_desc1')
        }
    }
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    cancel() {
      this.$emit('input', {});
      this.$parent.changeStep('formBasic');
    },
  },
};
</script>

<style lang="scss">
.card-thanks {
  position: relative;
  width: 100%;
  min-height: 300px;
  .bg {
    width: 160px;
    height: 160px;
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right;
    background-image: url('../../assets/thanks-bg1.png');
  }
  .card-content {
    display: flex;
    flex-direction: column;
    gap: 78px;
  }
  .card-title {
    font-family: 'Taviraj', sans-serif;
    // font-family: 'Pattaya', sans-serif;
    font-size: 33px;
    font-weight: 700;
    margin-top: 50px;
    text-align: center;
    line-height: 50px;
    // -webkit-text-fill-color: transparent;
    // background: linear-gradient(to bottom, #dfcb96, #dc9774);
    // -webkit-background-clip: text;
    color: #dc9774cc;
  }
  .card-title-desc {
    font-size: 23px;
    font-weight: 500;
    color: #dc9774cc;
    line-height: 30px;
  }
  .card-text {
    font-size: 16px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .van-icon {
    position: absolute;
    right: 0;
    top: 0;
    border: 1px solid;
    padding: 2px;
    border-radius: 50%;
  }
}
</style>
